import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { formatDateMMDDYY, YYYYMMDDtoMMDDYY } from '@mummssoftware/utils/formatters';
import { getFirstUserCredential, getLastUserCredential } from '../utils/utils';
import { styles } from '../../../utils';
import defaults from '../../../translations/en.json';

var _ref = /*#__PURE__*/React.createElement(Text, null);

var _ref2 = /*#__PURE__*/React.createElement(Text, null);

var _ref3 = /*#__PURE__*/React.createElement(Text, null);

export const CPPListingPDF = ({
  plan
}) => {
  const createdText = plan.createpersonlastname ? `${defaults.createdBy} ${getFirstUserCredential(plan)} ${defaults.on}` : `${defaults.createdOn}`;
  const updatedText = plan.modifiedpersonlastname ? `${defaults.updatedBy} ${getLastUserCredential(plan)} ${defaults.on}` : `${defaults.updatedOn}`;
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100, styles.paddingTopPointOneCm]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${defaults.patient} ${plan.patientfirstname} ${plan.patientlastname} - ${plan.patientnumber}`), plan.originalsubmitdate !== '' ? /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${defaults.initiated} ${defaults.on} ${YYYYMMDDtoMMDDYY(plan.originalsubmitdate)}`) : _ref, /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${defaults.effective} ${YYYYMMDDtoMMDDYY(plan.effectivedate)}`), /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${createdText} ${formatDateMMDDYY(plan.createdatetimeshifted)}`), plan.modifieddate ? /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${updatedText} ${formatDateMMDDYY(plan.modifieddatetimeshifted)}`) : _ref2, plan.resolveddate !== '' ? /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.pYPointOneCm]
  }, `${defaults.resolved} ${YYYYMMDDtoMMDDYY(plan.resolveddate)}`) : _ref3);
};